import { Text, VStack } from 'ui_2';

export const LoadingMessage = ({ message }: { message: string }) => {
  return (
    <VStack className='flex min-h-[100dvh] items-center justify-center'>
      <VStack className='max-w-4/5 rounded-[10px] border border-gray-100 bg-gray-50 p-4 text-center'>
        <Text>{message}</Text>
      </VStack>
    </VStack>
  );
};
